export default {"src":"/_next/static/media/0xffffffff7d2b0b761af01ca8e25242976ac0ad7d.6f7cbaef.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};